import { RichText } from "component/richtext";
import { UtilityText } from "component/text";
import { useState } from "react";
import { component, DemoBox, demoFile, story, CLICK } from "system/demo";

demoFile('component/richtext');

function RichTextDemo() {
    const [clicked, setClicked] = useState(false);
    const onPress = () => setClicked(true);
    return <DemoBox>
        <RichText text='Text with **bold text** and a [link]({url})' formatParams={{param: 'parameter', url: 'https://example.com'}} />
        <RichText text='Text with a [callback]($onPress)' callbacks={{onPress}} />
        {clicked && <UtilityText text='clicked'/>}
    </DemoBox>;
}

component('RichText', RichTextDemo, {}, [
    story('Callback Link', [CLICK('callback')])
])

